import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Industrial Automation, Machinery & Software Solutions</h1>
            <p className="hero-subtitle">
              Delivering precision-engineered automation systems, custom machinery, and software solutions for manufacturing excellence
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn btn-primary">Get Started</Link>
              <Link to="/services" className="btn">Our Services</Link>
            </div>
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="about-preview">
        <div className="container">
          <div className="section-header">
            <h2>About SCE Automated</h2>
            <p className="section-subtitle">
              Leading the future of industrial automation with innovative solutions
            </p>
          </div>
          <div className="about-content">
            <div className="about-text">
              <p>
                SCE Automated is a premier provider of industrial automation, custom machinery, and software solutions. 
                Our multidisciplinary team of Mechanical Designers, Controls Electrical Engineers, and Software Engineers 
                enables us to design and build complete machines and production lines from scratch, as well as provide 
                specialized services including controls commissioning and custom software development.
              </p>
              <p>
                With expertise spanning PLC programming (Rockwell, Siemens, Beckhoff, Bosch), robotics integration 
                (Fanuc, Kuka, ABB, Epson, Denso, Yaskawa, Staubli), SCADA systems (Ignition, .NET, React + Node.js), 
                MES systems, traceability solutions, and web applications, we deliver comprehensive turnkey solutions 
                that meet the most demanding manufacturing requirements.
              </p>
              <p>
                Based in the USA, we provide support across North America, Central & South America, and Europe.
              </p>
              <Link to="/about" className="btn">Learn More</Link>
            </div>
            <div className="about-image">
              <img src="/SCE_Press_Aptiv.jpeg" alt="SCE Automated - Automation Technology" className="about-image-img" />
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview">
        <div className="container">
          <div className="section-header">
            <h2>Our Services</h2>
            <p className="section-subtitle">
              Comprehensive automation solutions tailored to your needs
            </p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">⚙️</div>
              <h3>PLC Programming</h3>
              <p>Custom programmable logic controller solutions for industrial automation</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🖥️</div>
              <h3>HMI Development</h3>
              <p>Intuitive human-machine interfaces for seamless operator interaction</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🤖</div>
              <h3>Robotics Integration</h3>
              <p>Advanced robotic systems for precision manufacturing processes</p>
            </div>
            <div className="service-card">
              <div className="service-icon">👁️</div>
              <h3>Vision Systems</h3>
              <p>Machine vision solutions for quality control and inspection</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🔧</div>
              <h3>Custom Machinery</h3>
              <p>Design and build of specialized automation equipment</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🛠️</div>
              <h3>System Integration</h3>
              <p>End-to-end integration of automation systems and controls</p>
            </div>
            <div className="service-card">
              <div className="service-icon">💻</div>
              <h3>MES Systems</h3>
              <p>Manufacturing Execution Systems for real-time production control</p>
            </div>
            <div className="service-card">
              <div className="service-icon">📊</div>
              <h3>Traceability Systems</h3>
              <p>Complete tracking solutions for compliance and quality control</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🔍</div>
              <h3>Computer Vision</h3>
              <p>Advanced vision systems with machine learning for inspection</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🌐</div>
              <h3>Web Solutions</h3>
              <p>Custom web applications and dashboards for manufacturing</p>
            </div>
          </div>
          <div className="text-center" style={{ marginTop: '40px' }}>
            <Link to="/services" className="btn">View All Services</Link>
          </div>
        </div>
      </section>

      {/* Industries Preview */}
      <section className="industries-preview">
        <div className="container">
          <div className="section-header">
            <h2>Industries We Serve</h2>
            <p className="section-subtitle">
              Expertise across multiple manufacturing sectors
            </p>
          </div>
          <div className="industries-grid">
            <div className="industry-item">Automotive</div>
            <div className="industry-item">Medical Devices</div>
            <div className="industry-item">Consumer Products</div>
            <div className="industry-item">Aerospace</div>
            <div className="industry-item">Electronics</div>
            <div className="industry-item">Food & Beverage</div>
          </div>
          <div className="text-center" style={{ marginTop: '40px' }}>
            <Link to="/industries" className="btn">Explore Industries</Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Automate Your Manufacturing?</h2>
            <p>Let's discuss how we can help optimize your production processes</p>
            <Link to="/contact" className="btn btn-primary">Contact Us Today</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

